import Reveal from "react-reveal/Reveal";
import { useMediaQuery as useMediaQueryNative } from "react-responsive";

import useMediaQuery from "../../utils/media-queries";
import { Desktop } from "./Desktop";
import { Medium } from "./Medium";
import { Small } from "./Small";
import { Mobile } from "./Mobile";

export function TalkToUsNow() {
  const { isDesktop } = useMediaQuery();
  const isMedium = useMediaQueryNative({ query: "(min-width: 934px)" });
  const isSmall = useMediaQueryNative({ query: "(min-width: 690px)" });

  let Component = Mobile;
  if (isSmall) Component = Small;
  if (isMedium) Component = Medium;
  if (isDesktop) Component = Desktop;
  return (
    <Reveal>
      <Component
        title="Talk to us now."
        description="Description for the Talk to Us section"
        image="img/talk-to-us.png"
        buttonText="Talk to us"
      />
    </Reveal>
  );
}
